import { ColDef } from 'ag-grid-community';
import { t } from 'i18next';

import { ActionsCell } from './cells';

interface IColumnDefParams {
  pricingProfileId: number;
  projectId: number;
}

export const getColumnDef = ({ pricingProfileId, projectId }: IColumnDefParams): ColDef[] => [
  {
    colId: 'actions',
    width: 50,
    maxWidth: 50,
    sortable: false,
    resizable: false,
    cellRenderer: ActionsCell,
    cellRendererParams: { pricingProfileId, projectId },
    suppressColumnsToolPanel: true,
    pinned: 'left',
    lockPinned: true,
  },
  {
    colId: 'name',
    headerName: t('headerCustomers'),
    field: 'name',
    filter: 'agTextColumnFilter',
    flex: 1,
    minWidth: 200,
  },
  {
    colId: 'externalCustomerNumber',
    headerName: t('headerCustomerNumber'),
    field: 'externalCustomerNumber',
    filter: 'agTextColumnFilter',
    minWidth: 150,
  },
  {
    colId: 'companyAddressName',
    headerName: t('headerLocation'),
    field: 'companyAddressName',
    filter: 'agTextColumnFilter',
    minWidth: 150,
  },
];
